import React from "react";

const HtmlView = ({ htmlContent }) => {
  return (
    <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default HtmlView;